import { Injectable } from '@angular/core';
import { SideMenuService } from 'src/app/services/side-menu.service';
import { AppDataService } from 'src/app/services/app-data.service';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import { Storage } from '@ionic/storage-angular';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Device } from '@capacitor/device';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  systemLanguage = new BehaviorSubject([]);
  resultArray;
  NotificationBadge = new BehaviorSubject<any>(null);
  ReadedNotification: any = [];
  user_id: any;
  user_role: any;
  constructor(
    private menuService: SideMenuService,
    private dataService: AppDataService,
    private storage: Storage,
    private storageService: StorageService,
    private authenticationService: AuthenticationService,

  ) {
    // this.getUserInfo()
  }
  async getUserInfo() {
    this.user_id = await this.storage.get('userId')
    this.user_role = await this.storage.get('userType')
  }
  async initializeData(routeId) {
    this.getUserInfo()
    this.resultArray = [];
    const tempItems: any = await this.dataService.getData('notifications_directus_users', null, '*.*.*', '-id', { 'directus_users_id': this.user_id, user_role: this.user_role });
    if (tempItems && tempItems.data.length > 0) {
      this.resultArray = [];
      tempItems.data.forEach(element => {
        if (element.notifications_id) {
          this.resultArray.push(element.notifications_id);
        }
      });
      // try {
      //   const notiItems: any = await this.dataService.getData('notifications', null, '*.*', '-id', { 'user_type': 'all' });
      //   if (notiItems && notiItems.data.length > 0) {
      //     notiItems.data.forEach(element => {
      //       this.resultArray.push(element);
      //     });
      //   }
      // } catch (err) {

      // }
      this.resultArray.filter(i => { return i.is_visible == true })
      this.resultArray = this.resultArray.sort((a, b) => (a.id < b.id) ? 1 : -1)
    } else {
      // try {
      //   const notiItems: any = await this.dataService.getData('notifications', null, '*.*.*', '-id', { 'user_type': 'all' });
      //   if (notiItems && notiItems.data.length > 0) {
      //     notiItems.data.forEach(element => {
      //       this.resultArray.push(element);
      //     });
      //   }
      // } catch (err) {

      // }
      this.resultArray.filter(i => { return i.is_visible == true })
      this.resultArray = this.resultArray.sort((a, b) => (a.id < b.id) ? 1 : -1)
    }
    const deviceInfo = await Device.getId();
    try {
      if (this.authenticationService.isLoggedIn) {
        const notification_read: any = await this.dataService.getData('notification_read', null, '*', null, { user_id: this.user_id, user_role: this.user_role });
        if (notification_read?.data.length > 0) {
          this.ReadedNotification = notification_read.data
        }
      } else {
        const notification_read: any = await this.dataService.getData('notification_read', null, '*', null, { 'udid': deviceInfo.uuid });
        if (notification_read?.data.length > 0) {
          this.ReadedNotification = notification_read.data
        }
      }
    } catch (err) {
      this.ReadedNotification = [];
    }

    this.resultArray.forEach(async element => {
      if (this.ReadedNotification?.length > 0) {
        var avail = await this.include(this.ReadedNotification, element);
        if (avail > -1) {
          element.unread = false;
        } else {
          element.unread = true;
        }
      } else {
        element.unread = true;
      }
    });
    // get System Language Data from Data service
    this.systemLanguage.next(this.dataService.systemLanguages[0]);
    // this.resultArray = tempItems.data;
    // Show latest notification on top.
    // this.resultArray.sort((a: any, b: any) => b.id - a.id);
    setTimeout(() => {
      var unread_length = this.resultArray.filter((cl) => {
        return cl.unread == true;
      });
      this.setDataInStorage('IsBadge', unread_length.length);
      setTimeout(() => {
        this.NotificationBadge.next(unread_length.length)
      }, 300);
    }, 1000);
    return [...this.resultArray];
  }

  async getreadedNotification() {
    const deviceInfo = await Device.getId();
    if (this.authenticationService.isLoggedIn) {
      const notification_read: any = await this.dataService.getData('notification_read', null, '*', null, { 'user_id': (await this.storage.get('userData'))?.id, user_role: this.user_role });
      if (notification_read?.data.length > 0) {
        this.ReadedNotification = notification_read.data
      }
    } else {
      const notification_read: any = await this.dataService.getData('notification_read', null, '*', null, { 'udid': deviceInfo.uuid });
      if (notification_read?.data.length > 0) {
        this.ReadedNotification = notification_read.data
      }
    }
  }

  include(arr, obj) {
    return (arr.findIndex(x => x.notification_id == obj.id));
  }

  getDataFromStorage(key) {
    return this.storageService.getFromLocalStorage(key);
  }
  setDataInStorage(key, value) {
    this.storageService.setInLocalStorage(key, value);
  }
}
